import { ArrowType } from '@ardoq/api-types';
import type { Point } from '@ardoq/math';
import { logWarn } from '@ardoq/logging';
import { markerShapes, paintMarkerShapes } from './markerShapes';

const drawMarker = (
  context: CanvasRenderingContext2D,
  arrow: ArrowType,
  anchor: Point,
  angle: number,
  size: number
) => {
  if (arrow === ArrowType.NONE) {
    return;
  }

  const shapes = markerShapes(arrow);

  if (shapes.length === 0) {
    logWarn(Error('unrecognized arrow type'), null, { arrow });
    return;
  }

  context.save();
  paintMarkerShapes(context, shapes, { anchor, angle, size });
  context.restore();
};
export { drawMarker };
